import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const Privacy = props => {

    useEffect(() => {
        window.scrollTo(0,0);
    }, [])

    return (
        <div className="main-100 privacy-policy">

            <Helmet>
                <meta charSet="utf-8" />
                <title>Child Safety and Protection Standards | Followone</title>
                <meta name="description" content="Your privacy is important to us." />
                <link rel="canonical" href="https://followone.com/csae" />
            </Helmet>

                <div className="main-100-header mgt-lg">
                    <h1>Standards Against Child Sexual Abuse and Exploitation (CSAE)</h1>
                    <p>Your privacy is important to us.</p>
                </div>

                <div className="legal-text">

                    <p>At Followone Inc., we are committed to creating a safe and respectful environment for all users. We have zero tolerance for any content or behavior that exploits or endangers children. In alignment with Google Play’s Developer Program Policy and international legal standards, we maintain and enforce the following standards to prevent Child Sexual Abuse and Exploitation (CSAE):</p>

                    <h4 className="mgb-sm">1. Zero Tolerance Policy</h4>

                    <p>We prohibit any content that depicts, promotes, or threatens child sexual abuse or exploitation in any form, including:</p>

                    <ul className="mgb-sm">
                        <li>Child sexual abuse material (CSAM)</li>
                        <li>Sexualized or exploitative depictions of minors</li>
                        <li>Grooming or predatory behavior toward minors</li>
                        <li>Any content that encourages, glorifies, or instructs CSAE activities</li>
                    </ul>

                    <h4 className="mgb-sm">2. User-Generated Content Moderation</h4>

                    <p>We actively monitor and moderate user-submitted photos, videos, and text content using a combination of automated tools and manual review. Suspicious or harmful content is removed immediately, and offending accounts are permanently banned.</p>

                    <h4 className="mgb-sm">3. Reporting and Response</h4>

                    <p>Users can report inappropriate content or behavior through the app’s built-in reporting features. We promptly investigate all reports and take appropriate actions, including:</p>

                    <ul className="mgb-sm">
                        <li>Content removal</li>
                        <li>Account suspension or termination</li>
                        <li>Reporting to law enforcement or child protection agencies where applicable</li>
                    </ul>

                    <h4 className="mgb-sm">4. Collaboration with Authorities</h4>

                    <p>We cooperate fully with law enforcement and child protection organizations. We report verified CSAE incidents to the National Center for Missing and Exploited Children (NCMEC) and/or relevant local authorities.</p>

                    <h4 className="mgb-sm">5. Education and Prevention</h4>

                    <p>We educate our team and community on the importance of child safety. Our moderators and developers are trained to recognize and respond to CSAE-related risks.</p>

                    <h4 className="mgb-sm">6. Technology and Detection</h4>

                    <p>We use industry-standard tools such as PhotoDNA and Google CSAI Match to detect known CSAM and prevent it from being uploaded or shared on our platform.</p>

                    <h4 className="mgb-sm">Contact Us</h4>

                    <p>To report abuse or learn more about our safety policies, contact us at: <a href="mailto:support@followone.com">support@followone.com</a></p>

                </div>
        </div>
    );
}

export default Privacy;